module.exports = __webpack_public_path__ + "static/media/ljubljana-22.cfc9e176.jpg";